const AppointmentDetailsLoader = () => {
  return (
    <div>
      <div className="mb-2 h-48 w-full animate-pulse rounded-lg bg-gray-400" />
      <div className="my-4 h-4 w-40 animate-pulse rounded-md bg-gray-400" />
      <div className="mt-8 flex items-center gap-2">
        <div className="mb-2 h-4 w-16 animate-pulse rounded-md bg-gray-400" />
        <div className="mb-2 h-4 w-14 animate-pulse rounded-md bg-gray-400" />
      </div>

      <div className="mt-10">
        <div className="mt-2 flex items-center justify-between">
          <div className="mb-2 h-4 w-24 animate-pulse rounded-md bg-gray-400" />
          <div className="mb-2 h-4 w-20 animate-pulse rounded-md bg-gray-400" />
        </div>
        <div className="mt-2 flex items-center justify-between">
          <div className="mb-2 h-4 w-24 animate-pulse rounded-md bg-gray-400" />
          <div className="mb-2 h-4 w-20 animate-pulse rounded-md bg-gray-400" />
        </div>
        <div className="mt-2 flex items-center justify-between">
          <div className="mb-2 h-4 w-24 animate-pulse rounded-md bg-gray-400" />
          <div className="mb-2 h-4 w-20 animate-pulse rounded-md bg-gray-400" />
        </div>
      </div>
    </div>
  );
};

export default AppointmentDetailsLoader;
